<template>
  <div>
    <AppLoadingContainer :predicate="isLoading">
      <div class="card-body">
        <div class="card">
          <div class="card-header bg-dark text-white">
            Active People
          </div>
          <div class="card-body">
            <template v-for="database in databaseActivePeople">
              <BTable :busy="isLoading"
                      :fields="activePeopleTableColumns"
                      :items="database.tables"
                      :responsive="true"
                      primary-key="table"
                      show-empty
                      striped
                      table-class="table-align-middle"
                      caption-top
                      :key="database.database">
                <template #table-caption><p class="bg-secondary" style="color: white; padding: 10px; margin: 0px;">{{ database.database }} DB</p></template>
              </BTable>
            </template>
          </div>
        </div>
      </div>
    </AppLoadingContainer>
  </div>
</template>

<script>
import DatabaseStatisticsService from "@/services/DatabaseStatisticsService";
import AppLoadingContainer from "../shared/AppLoadingContainer";

export default {
  components: {
    AppLoadingContainer
  },
  data() {
    return {
      isLoading: true,
      databaseActivePeople: [],
      activePeopleTableColumns: [
        {
          key: "table",
          label: "Table"
        }, 
        {
          key: "numberActivePeople",
          label: "# Active People"
        }
      ]
    };
  },
  computed: {
    today() {
      return new Date()
    }
  },
  methods: {
    loadData() {
      DatabaseStatisticsService.getActivePeopleDatabaseStatistics()
        .then(response => {
          this.databaseActivePeople = response;
        })
        .catch(() => {
          this.redirectToError();
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    this.loadData();
  }
};
</script>